import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

import {
  Chart,
  ChartProps,
  Icon,
  type Ryecon,
  RyeconCheckmarkOutline,
  RyeconErrorOutline,
} from '@dbt-labs/sourdough';

type MissingDataStyle = 'error' | 'neutral' | 'success';

type ChartWrapperProps = ChartProps & {
  missingDataStyle?: MissingDataStyle;
  noDataMessage: ReactNode | undefined;
  numDataPoints: number | undefined;
  testId?: string;
};

const iconMap: Record<MissingDataStyle, Ryecon> = {
  error: RyeconErrorOutline,
  neutral: RyeconErrorOutline,
  success: RyeconCheckmarkOutline,
};

export const ChartWrapper = ({
  missingDataStyle = 'neutral',
  numDataPoints,
  noDataMessage = 'No data available',
  ...props
}: ChartWrapperProps) => {
  if (numDataPoints === 0 && noDataMessage && !props.isLoading && !props.error) {
    return (
      <div className="relative">
        <Chart {...props} />
        <div
          className="absolute inset-0"
          style={{
            marginLeft: props.margin.left,
            marginRight: props.margin.right,
            marginBottom: props.margin.bottom || 0 + (props.margin.top || 0),
          }}
        >
          <div
            className={twJoin(
              'relative h-full text-center',
              missingDataStyle === 'error' && 'text-fgDanger',
              missingDataStyle === 'neutral' && 'text-fgDecorative',
              missingDataStyle === 'success' && 'text-fgSuccess',
            )}
          >
            <div className="absolute top-1/2 h-0 w-full text-center text-base">
              <div className="-translate-y-1/2">
                <Icon ryecon={iconMap[missingDataStyle]} size="lg" />
                <div className="mt-2">{noDataMessage}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return <Chart {...props} />;
};
